import * as React from 'react'
import { Buttons, Col, ContainerWithPadding, defaultLabelSort, FormFieldWrapper, Popup, PopupFormWrapper, Row, SelectFormField, SelectOptionModel } from 'traveldesk-ui'
import City from '../../models/City'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from 'traveldesk-ui/dist/store'
import { useCountriesOptions } from '../../effects/useCountriesOptions'
import CitiesApiService from '../../services/CitiesApiService'
interface Props {
    onClose: () => void
    cities: City[]
    onSubmit: (cities: City[]) => void
}
const AdminCitiesOfOperationForm = (props: Props) => {
    const dispatch = useDispatch()
    const [countryId, setCountryId] = React.useState<number | undefined>(props.cities?.length > 0 ? props.cities[0].countryId : undefined)
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const countriesOptions = useCountriesOptions()
    const [selectedCities, setSelectedCities] = React.useState<City[]>(props.cities)
    const [citiesOptions, setCitiesOptions] = React.useState<SelectOptionModel[]>([])
    React.useEffect(() => {
        getCitiesOptions()
    }, [countryId])
    const getCitiesOptions = async () => {
        if (countryId) {
            const citiesOptions = await CitiesApiService.getCitiesInCountries(dispatch, [countryId as number])
            if (citiesOptions.IsOk && citiesOptions.Content) {
                setCitiesOptions((citiesOptions.Content ?? []).map(c => ({ label:c.name, value: c.id } as SelectOptionModel)).sort(defaultLabelSort))
            }
        }
    }
    const countriesOptionsWithMeta = React.useMemo(() => {
        return countriesOptions.map(country => {
            const citiesInCountry = selectedCities.filter(city => city.countryId === country.value)
            return {
                ...country, label: citiesInCountry.length > 0 ? `${country.label} (${citiesInCountry.length})` : country.label
            }
        })
    }, [countriesOptions, selectedCities])
    return (
        <ContainerWithPadding>
            <br /><br /><br />
            <Popup onClose={props.onClose}>
                <PopupFormWrapper>
                    <h4>Cities of Operation</h4>
                    <Row>
                        <Col type="50">
                            <FormFieldWrapper>
                                <label>Country</label>
                                <SelectFormField
                                    value={countryId}
                                    onChange={(e: SelectOptionModel) => {
                                        setCountryId(e.value as number)
                                    }}
                                    options={countriesOptionsWithMeta}
                                />
                            </FormFieldWrapper>
                        </Col>
                        <Col type="50">
                            <FormFieldWrapper>
                                <label>Cities</label>
                                <SelectFormField
                                    isMultiple
                                    value={selectedCities.map(city => city.id)}
                                    options={citiesOptions}
                                    onChangeMulti={(e: SelectOptionModel[]) => {
                                        setSelectedCities(selectedCities.filter(city => city.countryId !== countryId)
                                            .concat(e.map(city => ({ id: city.value as number, countryId: countryId as number, name: city.label, countryName: city.label }))))
                                    }}
                                    onClear={() => {
                                        setSelectedCities(selectedCities.filter(city => city.countryId !== countryId))
                                    }}
                                />
                            </FormFieldWrapper>
                        </Col>
                    </Row>
                    <hr />
                    <FormFieldWrapper>
                        <label>Selected cities</label>
                        <div style={{ margin: 0 }} className="custom_select_result">
                            {selectedCities.map(city => {
                                return (
                                    <span className="multiple-value-item">{city.name} ({city.countryName})<i></i></span>
                                )
                            })}
                        </div>
                    </FormFieldWrapper>
                </PopupFormWrapper>
                <Buttons.StickySaveButton onClick={() => { props.onSubmit(selectedCities) }}>{Localization.getString('Save')}</Buttons.StickySaveButton>
            </Popup>
        </ContainerWithPadding>
    )
}
export default AdminCitiesOfOperationForm